import { useState } from 'react';
import { useModal, useAuthModal } from 'Hooks';
import { fileType, currentUser } from 'Utils';
import { Button, UploadBox, ModalBoxUploadMedia } from 'Elements';
import styles from 'partials/story-box.module.scss';

export const SidebarStoryFrame = ({ children, type, hasMore, onShowMore }) => {
	const [openModalUpload, toggleModalUpload] = useModal();
	const [openModalAuth, toggleModalAuth] = useModal();
	const [modalName, setModalName] = useState('login');
	const AuthModal = useAuthModal(modalName);

	const handleModalChange = (modal_name) => {
		setModalName(modal_name);
	};

	const handleToggleMedia = () => {
		if (currentUser.isLogin()) {
			toggleModalUpload();
		} else {
			toggleModalAuth();
		}
	};

	return (
		<div className={styles.wrapper}>
			{children}
			{hasMore && (
				<Button className={styles.fullButton} onClick={onShowMore}>
					مشاهده همه {fileType[type].title} ها
				</Button>
			)}
			<UploadBox
				type={type}
				className="mt-15"
				onClick={handleToggleMedia}
			/>
			<ModalBoxUploadMedia
				isOpen={openModalUpload}
				onClose={handleToggleMedia}
				type={type}
				size="sm"
			/>
			<AuthModal
				size="sm"
				isOpen={openModalAuth}
				onClose={toggleModalAuth}
				onToggleLogin={() => handleModalChange('login')}
				onToggleForget={() => handleModalChange('forget')}
				onToggleRegister={() => handleModalChange('register')}
				onTogglePassword={() => handleModalChange('password')}
			/>
		</div>
	);
};
